'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGlobals$0024 from "./presto.-Globals$.js";
import * as $j_presto$002etypes$0024$002dFeatures$0024 from "./presto.types$-Features$.js";
import * as $j_presto$002etypes$0024$002dPlan$002dCode$0024 from "./presto.types$-Plan-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SingleAppToken(created, expires, user) {
  this.Yj = null;
  this.Yk = null;
  this.fi = null;
  this.Yj = created;
  this.Yk = expires;
  this.fi = user;
}
export { $c_Lpresto_types$SingleAppToken as $c_Lpresto_types$SingleAppToken };
$p = $c_Lpresto_types$SingleAppToken.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SingleAppToken;
/** @constructor */
function $h_Lpresto_types$SingleAppToken() {
}
export { $h_Lpresto_types$SingleAppToken as $h_Lpresto_types$SingleAppToken };
$h_Lpresto_types$SingleAppToken.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$SingleAppToken)) {
    var x = this.Yj;
    var x$2 = x$0.Yj;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.Yk;
      var x$4 = x$0.Yk;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.fi;
      var x$6 = x$0.fi;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "SingleAppToken";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Yj;
      break;
    }
    case 1: {
      return this.Yk;
      break;
    }
    case 2: {
      return this.fi;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.cIQ = (function(code) {
  return this.fi.rK.xc.cI(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$9) => _$9.Dp))).aE(code);
});
$p.cNV = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_IterableOnceOps__mkString__T__T__T__T(this.fi.rK.xc.cI(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$10) => _$10.Dp))).a3(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((t) => t))), "", ", ", "");
});
$p.adL = (function() {
  var this$1 = this.fi.ha.jb;
  var b = $j_presto$002e$002dGlobals$0024.$m_Lpresto_Globals$().mY;
  return ((this$1.e === b.e) && (this$1.f === b.f));
});
$p.cqp = (function() {
  return this.fi.rK.tO.cI(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$11) => _$11.Kw)));
});
$p.a1H = (function() {
  return this.fi.rK.tO.eo(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((p) => $j_presto$002etypes$0024$002dPlan$002dCode$0024.$m_Lpresto_types$PlanCode$().c7I.aE(p.Dq))));
});
$p.adK = (function(code) {
  return ((this.a1H().U() === 1) && this.a1H().gX(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$14) => (_$14.Dq === code)))));
});
$p.SF = (function(code) {
  return ((code === $j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().DR) ? (this.cqp().gX(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$15) => (_$15.Do === code)))) && this.SF($j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().lH)) : (this.a1H().k() || this.cqp().gX(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$16) => (_$16.Do === code))))));
});
function $isArrayOf_Lpresto_types$SingleAppToken(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ka)));
}
export { $isArrayOf_Lpresto_types$SingleAppToken as $isArrayOf_Lpresto_types$SingleAppToken };
var $d_Lpresto_types$SingleAppToken = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SingleAppToken, "presto.types$SingleAppToken", ({
  ka: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$SingleAppToken as $d_Lpresto_types$SingleAppToken };
//# sourceMappingURL=presto.types$-Single-App-Token.js.map
